import { EntityTypes } from 'constants/entities';
import { update } from 'core/actions/admin/data';
import { selectOfflineId } from 'core/selectors/admin/offlineId';
import { useAppDispatch, useAppSelector } from 'core/store/hooks';
import { useCallback } from 'react';
import { IText } from 'types/domain/text';

interface ParentAttributes {
  parentEntityId?: number;
  parentEntityType?: EntityTypes;
  parentEntityAttribute?: string;
  persist?: boolean;
  mergeData?: boolean;
}

export function useSave(
  type: EntityTypes,
  parentEntityType?: EntityTypes,
  parentEntityId?: number,
): (text: any, attributes?: ParentAttributes) => void {
  const dispatch = useAppDispatch();
  const parentCourseId = useAppSelector(state => state.state[EntityTypes.COURSE]);
  const parentModuleId = useAppSelector(state => state.state[EntityTypes.MODULE]);
  const offlineId = useAppSelector(selectOfflineId);

  const save = useCallback(
    (entity, attributes) => {
      const updatedEntity = { ...(entity?.id ? entity : { ...entity, id: offlineId, offlineId }) };

      dispatch(
        update({
          type,
          parentEntityType,
          parentEntityId,
          parentModuleId,
          parentCourseId,
          entity: updatedEntity,
          ...(attributes ?? {}),
        }),
      );
    },
    [dispatch, offlineId, parentCourseId, parentEntityId, parentEntityType, parentModuleId, type],
  );

  return save;
}
